// @flow

import type { SectionType } from '../types/entities';

import type { DispatchType, GetStateType, ThunkType, ActionType } from '../types';

export const CREATE_SECTION = 'CREATE_SECTION';
export const DELETE_SECTION = 'DELETE_SECTION';
export const UPDATE_SECTION = 'UPDATE_SECTION';
export const REORDER_SECTIONS = 'REORDER_SECTIONS';

export const ADD_LINE_TO_SECTION = 'ADD_LINE_TO_SECTION';
export const REMOVE_LINE_FROM_SECTION = 'REMOVE_LINE_FROM_SECTION';
export const SWITCH_LINE_IN_SECTION = 'SWITCH_LINE_IN_SECTION';

export function createSection(
  obj: SectionType,
  index?: number,
): (dispatch: DispatchType, getState: GetStateType) => ThunkType<ActionType> {
  return (dispatch: DispatchType, getState: GetStateType): ActionType => {
    const id = Math.max(0, ...getState().song.sections.allIds) + 1;
    return dispatch({
      type: CREATE_SECTION,
      // id,
      obj: { ...obj, id },
      index,
    });
  };
}

export function deleteSection(id: number): ActionType {
  return { type: DELETE_SECTION, id };
}

export function updateSection(obj: SectionType): ActionType {
  return { type: UPDATE_SECTION, obj };
}

export function reorderLines(allIds: Array<number>): ActionType {
  return { type: REORDER_SECTIONS, allIds };
}

export function addLineToSection(sectionId: number, lineId: number, index?: number): ActionType {
  return {
    type: ADD_LINE_TO_SECTION,
    sectionId,
    lineId,
    index,
  };
}

export function removeLineFromSection(sectionId: number, index: number): ActionType {
  return { type: REMOVE_LINE_FROM_SECTION, id: sectionId, index };
}

export function switchLineInSection(sectionId: number, index: number, lineId: number): ActionType {
  return {
    type: SWITCH_LINE_IN_SECTION,
    sectionId,
    index,
    lineId,
  };
}



// WEBPACK FOOTER //
// ./src/actions/sections.js